module.exports = __webpack_public_path__ + "static/media/sdk-4.c907533d.svg";